export enum LandingPageListingCourseStatusEnum {
    Confirmed = 'confirmed',
    NotConfirmed = 'not_confirmed',
    Canceled = 'canceled',
}
